class GramiyaaStickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.section = null;
    this.mainProductForm = null;
    this.mainForm = null;
    this.mainVariantPicker = null;
    this.mainQuantityInput = null;
    this.variantIdInput = null;
    this.originalButton = null;
    this.visibilityTarget = null;

    this.observer = null;
    this.visibilityFrame = null;
    this.syncTimer = null;
    this.loadingTimer = null;

    this.onWindowScroll = this.onWindowScroll.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.onSectionChange = this.onSectionChange.bind(this);
    this.onSectionInput = this.onSectionInput.bind(this);
    this.onSectionClick = this.onSectionClick.bind(this);
    this.onSectionFocusOut = this.onSectionFocusOut.bind(this);
    this.onStickyVariantChange = this.onStickyVariantChange.bind(this);
    this.onStickyQuantityChange = this.onStickyQuantityChange.bind(this);
    this.onMinusClick = this.onMinusClick.bind(this);
    this.onPlusClick = this.onPlusClick.bind(this);
    this.onAddToCartClick = this.onAddToCartClick.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';

    this.variantSelect = this.querySelector('[data-sticky-variant]');
    this.quantityInput = this.querySelector('[data-sticky-quantity]');
    this.minusButton = this.querySelector(
      '[data-sticky-quantity-action="minus"]'
    );
    this.plusButton = this.querySelector(
      '[data-sticky-quantity-action="plus"]'
    );
    this.addButton = this.querySelector('[data-sticky-add-to-cart]');
    this.buttonText = this.querySelector('[data-sticky-button-text]');
    this.variantName = this.querySelector('[data-sticky-variant-name]');
    this.priceElement = this.querySelector('[data-sticky-price]');
    this.imageElement = this.querySelector('[data-sticky-image]');

    this.defaultButtonText =
      this.buttonText?.textContent?.trim() || 'Add to cart';

    this.section =
      document.getElementById(
        `shopify-section-${this.dataset.sectionId}`
      ) || this.closest('.shopify-section');

    if (!this.section) return;

    this.hidden = false;

    this.variantSelect?.addEventListener(
      'change',
      this.onStickyVariantChange
    );

    this.quantityInput?.addEventListener(
      'change',
      this.onStickyQuantityChange
    );

    this.quantityInput?.addEventListener(
      'blur',
      this.onStickyQuantityChange
    );

    this.minusButton?.addEventListener('click', this.onMinusClick);
    this.plusButton?.addEventListener('click', this.onPlusClick);
    this.addButton?.addEventListener('click', this.onAddToCartClick);

    this.section.addEventListener('change', this.onSectionChange);
    this.section.addEventListener('input', this.onSectionInput);
    this.section.addEventListener('click', this.onSectionClick);
    this.section.addEventListener('focusout', this.onSectionFocusOut);

    window.addEventListener('scroll', this.onWindowScroll, {
      passive: true,
    });

    window.addEventListener('resize', this.onWindowResize, {
      passive: true,
    });

    this.observer = new MutationObserver((mutations) => {
      const hasRelevantMutation = mutations.some(
        (mutation) => !this.contains(mutation.target)
      );

      if (!hasRelevantMutation) return;

      this.scheduleSync(30);
    });

    this.observer.observe(this.section, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'disabled',
        'class',
        'selected',
        'checked',
        'data-product-id',
      ],
    });

    this.refreshOriginalControls();
    this.syncEverything();
    this.requestVisibilityUpdate();
  }

  disconnectedCallback() {
    this.variantSelect?.removeEventListener(
      'change',
      this.onStickyVariantChange
    );

    this.quantityInput?.removeEventListener(
      'change',
      this.onStickyQuantityChange
    );

    this.quantityInput?.removeEventListener(
      'blur',
      this.onStickyQuantityChange
    );

    this.minusButton?.removeEventListener('click', this.onMinusClick);
    this.plusButton?.removeEventListener('click', this.onPlusClick);
    this.addButton?.removeEventListener(
      'click',
      this.onAddToCartClick
    );

    this.section?.removeEventListener('change', this.onSectionChange);
    this.section?.removeEventListener('input', this.onSectionInput);
    this.section?.removeEventListener('click', this.onSectionClick);
    this.section?.removeEventListener(
      'focusout',
      this.onSectionFocusOut
    );

    window.removeEventListener('scroll', this.onWindowScroll);
    window.removeEventListener('resize', this.onWindowResize);

    this.observer?.disconnect();

    if (this.visibilityFrame) {
      cancelAnimationFrame(this.visibilityFrame);
    }

    if (this.syncTimer) {
      clearTimeout(this.syncTimer);
    }

    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
  }

  refreshOriginalControls() {
    if (!this.section) return;

    const productForms = Array.from(
      this.section.querySelectorAll('product-form-component')
    ).filter(
      (element) =>
        !element.closest('product-card') &&
        !element.closest('quick-add-dialog') &&
        !element.closest('quick-add-modal')
    );

    this.mainProductForm =
      productForms.find(
        (element) =>
          element.dataset.productId === this.dataset.productId
      ) || productForms[0];

    if (this.mainProductForm?.dataset.productId) {
      this.dataset.productId =
        this.mainProductForm.dataset.productId;
    }

    this.mainForm =
      this.mainProductForm?.querySelector(
        'form[data-type="add-to-cart-form"]'
      ) || this.mainProductForm?.querySelector('form');

    this.variantIdInput =
      this.mainForm?.querySelector(
        'input[name="id"][ref="variantId"]'
      ) || this.mainForm?.querySelector('input[name="id"]');

    this.mainQuantityInput =
  this.mainForm?.querySelector(
    'input[name="quantity"]:not([data-cart-line])'
  ) || null;

    this.originalButton =
      this.mainForm?.querySelector('[ref="addToCartButton"]') ||
      this.mainForm?.querySelector('button[name="add"]') ||
      null;

    const variantPickers = Array.from(
      this.section.querySelectorAll('variant-picker')
    ).filter(
      (element) =>
        !element.closest('product-card') &&
        !element.closest('quick-add-dialog') &&
        !element.closest('quick-add-modal')
    );

    this.mainVariantPicker =
      variantPickers.find(
        (element) =>
          element.dataset.productId === this.dataset.productId
      ) || variantPickers[0];

    this.visibilityTarget =
  this.mainVariantPicker ||
  this.originalButton?.closest('.buy-buttons-block') ||
  this.mainProductForm ||
  null;
  }

  onWindowScroll() {
    this.requestVisibilityUpdate();
  }

  onWindowResize() {
    this.requestVisibilityUpdate();
  }

  requestVisibilityUpdate() {
    if (this.visibilityFrame) return;

    this.visibilityFrame = requestAnimationFrame(() => {
      this.visibilityFrame = null;
      this.updateVisibility();
    });
  }

  updateVisibility() {
    this.refreshOriginalControls();

    if (!this.visibilityTarget) {
      this.classList.remove('is-visible');
      this.setAttribute('aria-hidden', 'true');
      return;
    }

    const targetRect =
  this.visibilityTarget.getBoundingClientRect();

const viewportHeight =
  window.innerHeight || document.documentElement.clientHeight;

/*
 * Start showing when the variant picker enters the viewport,
 * then keep showing while the customer continues downward.
 */
const shouldShow = targetRect.top <= viewportHeight;

    this.classList.toggle('is-visible', shouldShow);
    this.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );
  }

  onSectionChange(event) {
    const target = event.target;

    if (!(target instanceof Element) || this.contains(target)) {
      return;
    }

    const picker = target.closest('variant-picker');

    if (
      picker &&
      !picker.closest('product-card') &&
      !picker.closest('quick-add-dialog')
    ) {
      this.setBusy('Updating…', 'updating');
      this.scheduleSync(60);

      window.setTimeout(() => {
        this.scheduleSync(0);
      }, 700);

      return;
    }

    if (
      target === this.mainQuantityInput ||
      target.matches('input[name="quantity"]')
    ) {
      this.scheduleSync(0);
    }
  }

  onSectionInput(event) {
    const target = event.target;

    if (!(target instanceof HTMLInputElement)) return;
    if (this.contains(target)) return;

    if (target.name === 'quantity') {
      this.scheduleSync(0);
    }
  }

  onSectionFocusOut(event) {
    const target = event.target;

    if (!(target instanceof HTMLInputElement)) return;
    if (this.contains(target)) return;

    if (target.name === 'quantity') {
      this.scheduleSync(0);
    }
  }

  onSectionClick(event) {
    const target = event.target;

    if (!(target instanceof Element) || this.contains(target)) {
      return;
    }

    if (
      target.closest(
        'quantity-selector-component button[name="minus"], quantity-selector-component button[name="plus"]'
      )
    ) {
      requestAnimationFrame(() => {
        this.syncQuantityFromMain();
      });
    }
  }

  onStickyVariantChange() {
    const selectedOption = this.variantSelect?.selectedOptions[0];

    if (!selectedOption) return;

    this.setBusy('Updating…', 'updating');
    this.updateProductSummary(selectedOption);
    this.applyQuantityRules(selectedOption);

    const wasApplied = this.applyVariantToMain(selectedOption);

    if (!wasApplied) {
      this.clearBusy(false);
      this.syncButtonState();
    }

    this.scheduleSync(150);

    window.setTimeout(() => {
      this.scheduleSync(0);
    }, 800);
  }

  applyVariantToMain(selectedOption) {
    this.refreshOriginalControls();

    if (!this.mainVariantPicker) return false;

    const optionValues = this.parseOptionValues(
      selectedOption.dataset.options
    );

    const groups = Array.from(
      this.mainVariantPicker.querySelectorAll('.variant-option')
    );

    if (!optionValues.length || !groups.length) return false;

    let finalEventTarget = null;

    optionValues.forEach((optionValue, index) => {
      const group = groups[index];

      if (!group) return;

      const radioInputs = Array.from(
        group.querySelectorAll('input[type="radio"]')
      );

      const matchingRadio = radioInputs.find(
        (input) => input.value === optionValue
      );

      if (matchingRadio) {
        radioInputs.forEach((input) => {
          input.checked = input === matchingRadio;
        });

        finalEventTarget = matchingRadio;
        return;
      }

      const select = group.querySelector('select');

      if (select instanceof HTMLSelectElement) {
        const matchingOption = Array.from(select.options).find(
          (option) => option.value === optionValue
        );

        if (!matchingOption) return;

        Array.from(select.options).forEach((option) => {
          const isSelected = option === matchingOption;

          option.selected = isSelected;

          if (isSelected) {
            option.setAttribute('selected', 'selected');
          } else {
            option.removeAttribute('selected');
          }
        });

        select.value = optionValue;
        finalEventTarget = select;
      }
    });

    if (!finalEventTarget) return false;

    finalEventTarget.dispatchEvent(
      new Event('change', {
        bubbles: true,
      })
    );

    return true;
  }

  onMinusClick() {
    if (!this.quantityInput) return;

    this.quantityInput.stepDown();
    this.commitStickyQuantity();
  }

  onPlusClick() {
    if (!this.quantityInput) return;

    this.quantityInput.stepUp();
    this.commitStickyQuantity();
  }

  onStickyQuantityChange() {
    this.commitStickyQuantity();
  }

  commitStickyQuantity() {
  if (!this.quantityInput) return;

  const quantity = this.clampQuantity(
    Number(this.quantityInput.value)
  );

  this.quantityInput.value = String(quantity);

  this.refreshOriginalControls();

  if (!this.mainForm) return;

  /*
   * Some Gramiyaa product templates do not render a visible
   * quantity input inside the original product form.
   * Shopify then defaults the submitted quantity to 1.
   *
   * Create a hidden quantity field when one does not exist.
   */
  if (!this.mainQuantityInput) {
    this.mainQuantityInput = document.createElement('input');
    this.mainQuantityInput.type = 'hidden';
    this.mainQuantityInput.name = 'quantity';
    this.mainQuantityInput.setAttribute(
      'data-gramiyaa-sticky-quantity',
      'true'
    );

    this.mainForm.appendChild(this.mainQuantityInput);
  }

  this.mainQuantityInput.value = String(quantity);

  this.mainQuantityInput.dispatchEvent(
    new Event('input', {
      bubbles: true,
    })
  );

  this.mainQuantityInput.dispatchEvent(
    new Event('change', {
      bubbles: true,
    })
  );
}

  clampQuantity(value) {
    if (!this.quantityInput) return 1;

    const minimum = Number(this.quantityInput.min) || 1;
    const maximum = this.quantityInput.max
      ? Number(this.quantityInput.max)
      : null;
    const increment = Number(this.quantityInput.step) || 1;

    let quantity = Number.isFinite(value) ? value : minimum;

    quantity = Math.max(quantity, minimum);

    if (maximum !== null && Number.isFinite(maximum)) {
      quantity = Math.min(quantity, maximum);
    }

    const distanceFromMinimum = quantity - minimum;
    const validSteps = Math.round(
      distanceFromMinimum / increment
    );

    quantity = minimum + validSteps * increment;

    if (maximum !== null && Number.isFinite(maximum)) {
      quantity = Math.min(quantity, maximum);
    }

    return quantity;
  }

  onAddToCartClick() {
    this.refreshOriginalControls();

    if (
      !this.originalButton ||
      this.originalButton.disabled ||
      this.dataset.state === 'updating'
    ) {
      this.syncButtonState();
      return;
    }

    if (
      this.variantSelect &&
      this.variantIdInput &&
      this.variantSelect.value !== this.variantIdInput.value
    ) {
      this.setBusy('Updating…', 'updating');
      this.scheduleSync(100);
      return;
    }

    this.commitStickyQuantity();
    this.setBusy('Adding…', 'adding');

    /*
     * Important:
     * Click the original Gramiyaa Add to Cart button instead of
     * submitting a new independent cart request.
     *
     * This preserves the existing product form, cart drawer,
     * button handlers and external pincode validation.
     */
    this.originalButton.click();

    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }

    this.loadingTimer = window.setTimeout(() => {
      this.clearBusy(false);
      this.refreshOriginalControls();
      this.syncButtonState();
    }, 2200);
  }

  scheduleSync(delay = 0) {
    if (this.syncTimer) {
      clearTimeout(this.syncTimer);
    }

    this.syncTimer = window.setTimeout(() => {
      this.syncTimer = null;
      this.syncEverything();
    }, delay);
  }

  syncEverything() {
    this.refreshOriginalControls();

    const selectedOption = this.syncVariantFromMain();

    this.syncQuantityFromMain();

    if (
      this.dataset.state === 'updating' &&
      selectedOption &&
      this.isVariantResolved()
    ) {
      this.clearBusy(false);
    }

    this.syncButtonState();
    this.requestVisibilityUpdate();
  }

  syncVariantFromMain() {
    if (!this.variantSelect) return null;

    let matchingOption = null;

    const selectedValues = this.getMainSelectedOptionValues();

    if (selectedValues.length) {
      matchingOption = Array.from(
        this.variantSelect.options
      ).find((option) => {
        const optionValues = this.parseOptionValues(
          option.dataset.options
        );

        return (
          optionValues.length === selectedValues.length &&
          optionValues.every(
            (value, index) => value === selectedValues[index]
          )
        );
      });
    }

    if (!matchingOption && this.variantIdInput?.value) {
      matchingOption = Array.from(
        this.variantSelect.options
      ).find(
        (option) => option.value === this.variantIdInput.value
      );
    }

    if (!matchingOption) return null;

    this.variantSelect.value = matchingOption.value;
    this.updateProductSummary(matchingOption);
    this.applyQuantityRules(matchingOption);

    return matchingOption;
  }

  getMainSelectedOptionValues() {
    if (!this.mainVariantPicker) return [];

    const groups = Array.from(
      this.mainVariantPicker.querySelectorAll('.variant-option')
    );

    return groups
      .map((group) => {
        const selectedRadio = group.querySelector(
          'input[type="radio"]:checked'
        );

        if (selectedRadio instanceof HTMLInputElement) {
          return selectedRadio.value;
        }

        const select = group.querySelector('select');

        if (select instanceof HTMLSelectElement) {
          return select.value;
        }

        return null;
      })
      .filter((value) => typeof value === 'string');
  }

  parseOptionValues(value) {
    if (!value) return [];

    try {
      const parsedValue = JSON.parse(value);

      return Array.isArray(parsedValue)
        ? parsedValue.map(String)
        : [];
    } catch (error) {
      console.warn(
        'Unable to read sticky cart variant options.',
        error
      );

      return [];
    }
  }

  applyQuantityRules(selectedOption) {
    if (!this.quantityInput) return;

    const minimum =
      Number(selectedOption.dataset.min) || 1;
    const increment =
      Number(selectedOption.dataset.step) || 1;
    const maximum = selectedOption.dataset.max
      ? Number(selectedOption.dataset.max)
      : null;

    this.quantityInput.min = String(minimum);
    this.quantityInput.step = String(increment);

    if (maximum !== null && Number.isFinite(maximum)) {
      this.quantityInput.max = String(maximum);
    } else {
      this.quantityInput.removeAttribute('max');
    }

    if (this.mainQuantityInput) {
      this.mainQuantityInput.min = String(minimum);
      this.mainQuantityInput.step = String(increment);

      if (maximum !== null && Number.isFinite(maximum)) {
        this.mainQuantityInput.max = String(maximum);
      } else {
        this.mainQuantityInput.removeAttribute('max');
      }
    }

    const currentQuantity =
      Number(
        this.mainQuantityInput?.value ||
          this.quantityInput.value ||
          minimum
      ) || minimum;

    const validQuantity =
      this.clampQuantity(currentQuantity);

    this.quantityInput.value = String(validQuantity);

    if (this.mainQuantityInput) {
      this.mainQuantityInput.value =
        String(validQuantity);
    }
  }

  syncQuantityFromMain() {
    if (!this.quantityInput || !this.mainQuantityInput) return;

    const mainQuantity = Number(
      this.mainQuantityInput.value
    );

    this.quantityInput.value = String(
      this.clampQuantity(mainQuantity)
    );
  }

  updateProductSummary(selectedOption) {
    if (this.variantName) {
      this.variantName.textContent =
        selectedOption.dataset.title || '';
    }

    if (this.priceElement) {
      this.priceElement.textContent =
        selectedOption.dataset.price || '';
    }

    const imageUrl = selectedOption.dataset.image;

    if (this.imageElement && imageUrl) {
      this.imageElement.src = imageUrl;
    }
  }

  isVariantResolved() {
    if (!this.variantSelect || !this.variantIdInput) {
      return true;
    }

    return (
      this.variantSelect.value ===
      this.variantIdInput.value
    );
  }

  syncButtonState() {
    if (!this.addButton || !this.buttonText) return;

    if (
      this.dataset.state === 'adding' ||
      (this.dataset.state === 'updating' &&
        !this.isVariantResolved())
    ) {
      return;
    }

    if (
      this.dataset.state === 'updating' &&
      this.isVariantResolved()
    ) {
      this.clearBusy(false);
    }

    const originalText =
      this.originalButton
        ?.querySelector('.add-to-cart-text__content')
        ?.textContent?.trim() ||
      this.originalButton?.textContent?.trim() ||
      this.defaultButtonText;

    const isDisabled =
      !this.originalButton || this.originalButton.disabled;

    this.addButton.disabled = isDisabled;
    this.addButton.classList.remove('is-loading');
    this.addButton.removeAttribute('aria-busy');
    this.buttonText.textContent = originalText;
  }

  setBusy(label, state) {
    if (!this.addButton || !this.buttonText) return;

    this.dataset.state = state;
    this.addButton.disabled = true;
    this.addButton.classList.add('is-loading');
    this.addButton.setAttribute('aria-busy', 'true');
    this.buttonText.textContent = label;
  }

  clearBusy(shouldSync = true) {
    delete this.dataset.state;

    this.addButton?.classList.remove('is-loading');
    this.addButton?.removeAttribute('aria-busy');

    if (shouldSync) {
      this.syncButtonState();
    }
  }
}

if (
  !customElements.get('gramiyaa-sticky-add-to-cart')
) {
  customElements.define(
    'gramiyaa-sticky-add-to-cart',
    GramiyaaStickyAddToCart
  );
}